import { AppState } from '../../../../store/app.state'

import * as fromUsers from '../reducers/users.reducer'

export const getUsersState = (state: AppState) => state.users

export const {
  selectIds: getUsersIds,
  selectEntities: getUsersEntities,
  selectAll: getUsersSelector,
  selectTotal: getTotalUsers,
} = fromUsers.adapter.getSelectors(getUsersState)




// WEBPACK FOOTER //
// ./src/app/shared/team/store/selectors/users.selectors.ts